'use strict';

var _ = require('lodash');
var CalculateEffectiveValueService = function CalculateEffectiveValueService(overridesUtilsService, effectiveValueFormulaService, constants, scenarioConstants) {
  var effectiveConfig = require('../config/gridEffectiveFields.json');
  var calculateConfig = require('../config/gridCalculatedFields.json');

  /**
   * This function checks if given row has an effective field corresponding to 'columnField'.
   * If it's present then the effective value is calculated and fieldname is returned for further processing in GridPanelController
   *
   * @param rowData data for the whole row where the value will be calculated
   * @param columnField field name for which the effective value should be calculated
   * @param gridId id of the grid used for getting available effective fields
   * @returns {{fieldName: ({fieldName, value}|*), value: *}}
   */
  function getEffectiveField(rowData, columnField, gridId) {
    var fields = effectiveConfig[gridId];
    var rootFieldName = overridesUtilsService.getRootFieldName(columnField);
    if (gridId === undefined || _.includes(fields, rootFieldName)) {
      var fieldName = overridesUtilsService.getEffectiveFieldName(columnField);
      var method = effectiveValueFormulaService.getFormula(fieldName);
      var value = method(rowData, columnField);
      return {
        fieldName: fieldName,
        value: value
      };
    }
  }
  function getCalculatedField(rowData, columnField, gridId) {
    var fields = calculateConfig[gridId];
    var calculationDefinition = _.find(fields, {
      source: columnField
    });
    if (calculationDefinition) {
      var targetField = calculationDefinition.target;
      var method = effectiveValueFormulaService.getFormula(targetField);
      var value = method(rowData, targetField);
      return {
        fieldName: targetField,
        value: value
      };
    }
  }
  function calculateAll(rowData, gridId) {
    var effectiveFields = effectiveConfig[gridId];
    var calculatedFields = calculateConfig[gridId];
    var result = {};

    // effective values
    _.forEach(effectiveFields, function (effectiveField) {
      var name = overridesUtilsService.getEffectiveFieldName(effectiveField);
      var method = effectiveValueFormulaService.getFormula(name);
      result[name] = method(rowData, effectiveField);
    });

    // calculated values
    _.forEach(calculatedFields, function (calculationDefinition) {
      var targetField = calculationDefinition.target;
      var method = effectiveValueFormulaService.getFormula(targetField);
      result[targetField] = method(rowData, targetField);
    });
    if (rowData.markRenormalize) {
      result.markRenormalize = true;
    }
    return result;
  }
  function setDefaultTypes(entry) {
    if (entry.scenarioName === scenarioConstants.PUBLISHED) {
      entry.userTypeRegularRemainingDemandFC = entry.userTypeRegularRemainingDemandFC || constants.DEFAULT_TYPE;
      entry.userTypeMappedRemainingDemandFC = entry.userTypeMappedRemainingDemandFC || constants.DEFAULT_TYPE;
    }
  }
  return {
    calculateAll: calculateAll,
    getField: getEffectiveField,
    getCalculatedField: getCalculatedField,
    setDefaultTypes: setDefaultTypes
  };
};
CalculateEffectiveValueService.$inject = ['OverridesUtilsService', 'EffectiveValueFormulaService', 'OverridesConstants', 'ScenarioConstants'];
module.exports = CalculateEffectiveValueService;